import React from 'react';
import { Tooltip, IconButton, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { notifications } from '../utils';

interface CopyToClipboardButtonProps {
  text: string;
  successMessage?: string;
}

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({ text, successMessage }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      notifications.success(successMessage || t('f-slaughterhouse-api-key-copy-success'));
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Tooltip title={copied ? t('f-com-copied') : t('f-com-copy')} arrow>
      <IconButton onClick={handleCopy} size="small">
        <Icon>{copied ? 'check' : 'content_copy'}</Icon>
      </IconButton>
    </Tooltip>
  );
};

export default CopyToClipboardButton;
